export default {"src":"/_next/static/media/seller-leads-home.3baaee26.svg","height":1080,"width":1080};